export default function Shop() {
  return (
    <>
      <div></div>
    </>
  );
}
